export default __webpack_public_path__ + "static/media/Service3.e52e81e9.jpg";